<div class="w-full h-screen">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- Logo Box -->
    <div class="flex flex-col w-4/5 p-5 pb-3 place-content-center">
      <a class="h-full w-full flex flex-col justify-center items-center" rel="noopener">
        <img class="w-2/5" [src]="logoUrl" alt="MAKEOS" />
      </a>
    </div>

    <div class="wrapper flex flex-col w-4/5 overflow-y-scroll items-center h-full max-w-screen-sm">
      <div class="flex flex-col w-full">
        <div class="flex flex-col h-full mb-2">
          <form class="registration-form" [formGroup]="signUpFormGroup" (ngSubmit)="signUpBtnClick()">
            <div>
              <h2 class="font-bold text-xl text-center mb-4">Sign up</h2>
            </div>

            <!-- First Name -->
            <div class="w-full">
              <span class="field-label">First name<sup>*</sup></span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput type="text" placeholder="First Name" formControlName="firstName" tabindex="1" />
                <mat-error *ngIf="signUpFormGroup.controls['firstName'].errors?.['required']"> First name is required </mat-error>
              </mat-form-field>
            </div>

            <!-- Last Name -->
            <div class="w-full">
              <span class="field-label">Last name<sup>*</sup></span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput type="text" placeholder="Last Name" formControlName="lastName" tabindex="2" />
                <mat-error *ngIf="signUpFormGroup.controls['lastName'].errors?.['required']"> Last name is required </mat-error>
              </mat-form-field>
            </div>

            <!-- Email address -->
            <div class="w-full">
              <span class="field-label">E-mail address<sup>*</sup></span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput type="text" placeholder="E-mail address" formControlName="email" tabindex="3" />
                <mat-error *ngIf="signUpFormGroup.controls['email'].errors?.['required']"> Email is required </mat-error>
                <mat-error *ngIf="signUpFormGroup.controls['email'].hasError('email') || signUpFormGroup.controls['email'].hasError('invalidEmail')"> Invalid email address </mat-error>
              </mat-form-field>
            </div>

            <!-- Password -->
            <div class="w-full">
              <span class="field-label">Password<sup>*</sup></span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput [type]="passwordInputType" placeholder="Password" formControlName="password" data-test-id="sign-up-field-password" tabindex="4" />
                <mat-icon class="cursor-pointer" matSuffix (click)="toggleVisibility()">{{ passwordVisible ? 'visibility' : 'visibility_off' }} </mat-icon>
                <mat-error *ngIf="signUpFormGroup.controls['password'].errors?.['required']"> Password is required </mat-error>
                <mat-error *ngIf="signUpFormGroup.controls['password'].hasError('passwordStrength')">
                  Password should have at least 8 characters, a special character, a number, a capital letter and a small letter
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Reason for Signup -->
            <div class="w-full">
              <span class="field-label">Reason for sign up<sup>*</sup></span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input type="text" matInput placeholder="Reason for sign up" formControlName="reasonForSignup" tabindex="5" />
                <mat-error *ngIf="signUpFormGroup.controls['reasonForSignup'].errors?.['required']"> This field is required </mat-error>
                <mat-error *ngIf="signUpFormGroup.controls['reasonForSignup'].errors?.['maxlength']"> Max length is 500 characters </mat-error>
              </mat-form-field>
            </div>

            <!-- Checkbox for Terms of Service -->
            <div class="w-full">
              <mat-checkbox formControlName="termsOfService" class="text-sm"> </mat-checkbox>
              <span class="text-gray-600"
                >I accept the <span role="link" class="cursor-pointer underline text-black" (click)="openTermsOfServiceDialog()"> terms of use and privacy policy </span></span
              >
              <mat-error *ngIf="signUpFormGroup.controls['termsOfService'].errors?.['required'] && signUpFormGroup.controls['termsOfService'].touched">
                Please accept the terms of use and privacy policy to sign up
              </mat-error>
            </div>

            <!-- Sign Up Button -->
            <div class="mb-3 w-full">
              <div class="w-full flex flex-col place-content-between items-center">
                <button mat-flat-button [disabled]="signUpFormGroup.invalid" class="flex-auto w-full button-primary" type="submit" data-test-id="btn-sign-up">Sign up</button>
              </div>
            </div>

            <!-- Sign up link -->
            <div class="sign-up-link flex flex-col justify-start items-center">
              <p>
                <span class="sign-up-message text-gray-600">Already have an account? </span>
                <a href="./login" class="text-blue-500">Back to login</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <sp-footer></sp-footer>
  </div>
</div>
